function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconManufacturer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/Manufactureur",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 232",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1221",
    d: "M16344.836 13193h-4.668a1.162 1.162 0 0 1-1.168-1.152v-2.43a1.161 1.161 0 0 1 .691-1.053l.641-10.377h-.164a.494.494 0 1 1 0-.988h3a.494.494 0 1 1 0 .988h-.168l.576 9.512.754-.164v-3.061a.49.49 0 0 1 .186-.381.5.5 0 0 1 .316-.111.431.431 0 0 1 .1.01l9.666 1.975a.5.5 0 0 1 .4.484v5.6a1.159 1.159 0 0 1-1.166 1.152zm6.832-2.8v.328a.5.5 0 0 0 .5.5h.332a.5.5 0 0 0 .5-.5v-.328a.5.5 0 0 0-.5-.494h-.332a.5.5 0 0 0-.5.494zm-2.668 0v.328a.5.5 0 0 0 .5.5h.334a.5.5 0 0 0 .5-.5v-.328a.5.5 0 0 0-.5-.494h-.334a.5.5 0 0 0-.5.494zm-2.666 0v.328a.5.5 0 0 0 .5.5h.336a.5.5 0 0 0 .5-.5v-.328a.5.5 0 0 0-.5-.494h-.336a.5.5 0 0 0-.5.494zm-5.5.33a.494.494 0 0 0 .5.49h1.334a.492.492 0 1 0 0-.984h-1.334a.5.5 0 0 0-.498.497zm10.832-2.965v.33a.5.5 0 0 0 .5.494h.332a.5.5 0 0 0 .5-.494v-.33a.5.5 0 0 0-.5-.494h-.332a.5.5 0 0 0-.498.497zm-2.668 0v.33a.5.5 0 0 0 .5.494h.334a.5.5 0 0 0 .5-.494v-.33a.5.5 0 0 0-.5-.494h-.334a.5.5 0 0 0-.498.497zm-2.666 0v.33a.5.5 0 0 0 .5.494h.336a.5.5 0 0 0 .5-.494v-.33a.5.5 0 0 0-.5-.494h-.336a.5.5 0 0 0-.498.497z",
    transform: "translate(-16335 -13173)",
    style: {
      fill: "#808285"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManufacturer);
export default __webpack_public_path__ + "static/media/icon_Manufacturer.d8249627.svg";
export { ForwardRef as ReactComponent };